
export class EncodingHelper {

    static decodeUrl(encodedString) {
        // Use decodeURIComponent to replace all encoded characters
		return decodeURIComponent(encodedString.replace(/%([0-9A-Fa-f]{2})/g, (match, p1) => String.fromCharCode(parseInt(p1, 16))));
    }
}